import { useState, useRef } from "react";
import { TbPlayerPlay, TbChevronDown } from "react-icons/tb";
import "./videoAccordion.scss";

type Props = {
    title: string;
    src: string;
};

export default function VideoAccordion({ title, src }: Props) {
    const [open, setOpen] = useState(false);
    const [everOpened, setEverOpened] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);

    const handleToggle = () => {
        if (!everOpened) setEverOpened(true);
        setOpen(o => !o);
    };

    return (
        <div className={`video-accordion${open ? " video-accordion--open" : ""}`}>
            <button type="button" className="video-accordion__trigger" onClick={handleToggle}>
                <TbPlayerPlay className="video-accordion__play-icon" />
                <span className="video-accordion__title">{title}</span>
                <TbChevronDown className="video-accordion__chevron" />
            </button>

            <div className="video-accordion__body">
                {everOpened && (
                    <div className="video-accordion__inner">
                        <div className="video-accordion__content">
                            <video
                                ref={videoRef}
                                className="video-accordion__video"
                                src={`${BASE_URL}${src}`}
                                controls
                                playsInline
                                preload="metadata"
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
